import * as React from 'react';
import { observer } from 'mobx-react';
import BaseSwiperStore from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import BackgroundImage from '@src/components/background-image';
import DateUtil from '@src/utils/date-util';

const styles = require('../../index.less');

const Strategy = ({ store }) => {
  store.use();
  return (
    <React.Fragment>
      <div className="main-layer-111" />
      <div className="main-layer-162" />

      <div className="main-group-51" data-name="轮播">
        <div className="main-layer-data-swiper">
          {store.strategyImgList?.length > 0 && (
            <BaseSwiperStore store={store.dataBannerBaseSwiperStore}>
              {store.strategyImgList.map((item, index) => {
                return (
                  <Link
                    onClick={() => {
                      store.onItemClick(item);
                    }}
                    className="main-layer-155"
                    key={index}
                  >
                    <BackgroundImage src={item.url} className="main-layer-155-item-content" />
                  </Link>
                );
              })}
            </BaseSwiperStore>
          )}
        </div>
        <div className="main-group-52" id="main-group-52" data-name="页码" />
      </div>

      <div className="main-group-50" data-name="页签">
        {store.currentTab === '最新' ? (
          <div className="main-layer-149" />
        ) : (
          <Link
            className="main-layer-149-default"
            onClick={() => {
              store.onTabClick('最新');
            }}
          />
        )}

        {store.currentTab === '新手' ? (
          <div className="main-layer-150" />
        ) : (
          <Link
            className="main-layer-150-default"
            onClick={() => {
              store.onTabClick('新手');
            }}
          />
        )}

        {store.currentTab === '玩法' ? (
          <div className="main-layer-152" />
        ) : (
          <Link
            className="main-layer-152-default"
            onClick={() => {
              store.onTabClick('玩法');
            }}
          />
        )}

        {/*{store.currentTab === '进阶' ? (*/}
        {/*  <div className="main-layer-153" />*/}
        {/*) : (*/}
        {/*  <Link*/}
        {/*    className="main-layer-153-default"*/}
        {/*    onClick={() => {*/}
        {/*      store.onTabClick('进阶');*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}

        <Link className="main-layer-154" onClick={store.onMoreClick} />
      </div>
      <div className="main-layer-148" />

      <div className="main-group-37" data-name="列表内容">
        {store.strategyList?.length > 0 &&
          store.strategyList.map((item, index) => {
            console.log('item', item);
            return (
              <Link
                onClick={() => {
                  store.onItemClick(item);
                }}
                key={index}
                className="main-strategy-item"
              >
                <div className="main-layer-142" />
                <div className="main-group-48" data-name="1">
                  <div className="main-layer-143" />
                  <div className="main-strategy-item-text-group">
                    <div className="main-layer-144" data-name="S2赛季开启！全新探索云滇花桥来啦!">
                      {item.title}
                    </div>
                    <div className="main-strategy-item-date">
                      <div className="main-startegy-time-m">{DateUtil.formatDate(new Date(item.published_at_show * 1000), 'MM')}</div>
                      <div className="main-startegy-time-d">{DateUtil.formatDate(new Date(item.published_at_show * 1000), 'dd')}</div>
                    </div>
                  </div>
                  <div className="main-layer-145" />
                  <div className="main-group-49" data-name="组 715">
                    <div className="main-layer-146" />
                    <div className="main-layer-147" data-name="进阶">
                      {item.categoryName}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>
    </React.Fragment>
  );
};

export default observer(Strategy);
